// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".post-title[data-v-bf14a3be]{font-family:Roboto,sans-serif;font-weight:500;font-size:16px}.category[data-v-bf14a3be]{color:#2cd5c4!important}.time[data-v-bf14a3be]{color:#7a7a7a}.card-image__img[data-v-bf14a3be]{-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
